/* Mabrouka — popup d'inscription (14.9.2026)
   Déclencheurs : délai, défilement, intention de sortie (souris seulement).
   Silence : visiteur inscrit (localStorage), fermé depuis moins de N jours, profil déjà connu de Klaviyo.
   Inscription : API client Klaviyo (subscriptions) → liste Email List → flux Welcome 2026. */
(function () {
  'use strict';
  var root = document.getElementById('mbr-popup');
  if (!root) return;
  var d = root.dataset;
  var cfg = { company: d.company, list: d.list, code: d.code, source: d.source, delay: d.delay, scroll: d.scroll, days: d.days, exit: d.exit === '1' };
  if (!cfg.company || !cfg.list) return;
  var KEY_DONE = 'mbr_popup_done', KEY_CLOSED = 'mbr_popup_closed';
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  // GA4 par le gtag de l'app Google & YouTube (comme mbr-bundle.js) + Clarity. Sans gtag, le dataLayer seul ne va nulle part.
  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, data || {}); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
  }

  if (lsGet(KEY_DONE)) return;
  var closedAt = parseInt(lsGet(KEY_CLOSED) || '0', 10);
  if (closedAt && Date.now() - closedAt < (cfg.days || 14) * 864e5) return;

  var form = root.querySelector('[data-popup-form]');
  var input = root.querySelector('#mbr-popup-email');
  var submit = root.querySelector('[data-popup-submit]');
  var err = root.querySelector('[data-popup-error]');
  var stepForm = root.querySelector('[data-step="form"]');
  var stepDone = root.querySelector('[data-step="done"]');
  var shown = false, armed = true, lastFocus = null, bannerWait = 0;

  // Profil déjà identifié par Klaviyo (clic depuis un email, inscription passée) : on ne redemande pas.
  function checkIdentified() {
    var k = window.klaviyo;
    if (k && typeof k.isIdentified === 'function') {
      try { k.isIdentified().then(function (v) { if (v) armed = false; }).catch(function () {}); } catch (e) {}
    }
  }
  setTimeout(checkIdentified, 1200);

  function open(trigger) {
    if (shown || !armed) return;
    // Fenêtre « 18+ » du thème pas encore validée : on attend, elle passe avant tout.
    if (document.querySelector('age-verifier') && !/beyours:age-verifier=/.test(document.cookie)) { setTimeout(function () { open(trigger); }, 2000); return; }
    // Bandeau cookies Shopify : sur mobile il occupe le bas de l'écran, là où s'ouvre le tiroir. On lui laisse
    // 6 secondes, puis on s'ouvre quand même (le popup passe au-dessus, le bandeau revient à la fermeture).
    // Avant le 17.9.2026 on attendait sans limite : les visiteurs qui ignorent le bandeau ne voyaient jamais le popup.
    var pc = document.getElementById('shopify-pc__banner');
    if (pc && pc.getBoundingClientRect().height > 0 && window.matchMedia('(max-width: 719px)').matches) {
      bannerWait = bannerWait || Date.now();
      if (Date.now() - bannerWait < 6000) { setTimeout(function () { open(trigger); }, 1500); return; }
    }
    if (document.body.classList.contains('overflow-hidden') || document.querySelector('.drawer.active, mini-cart.active, cart-drawer.active')) {
      // un tiroir (panier, menu) est ouvert : on réessaie un peu plus tard
      setTimeout(function () { open(trigger); }, 4000);
      return;
    }
    shown = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    document.documentElement.classList.add('mbr-popup-open');
    track('popup_shown', { popup_trigger: trigger });
    if (window.matchMedia('(pointer:fine)').matches) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, 400);
  }
  function close(reason) {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('mbr-popup-open');
    setTimeout(function () { root.hidden = true; }, 350);
    if (reason !== 'done') lsSet(KEY_CLOSED, String(Date.now()));
    track('popup_closed', { popup_reason: reason });
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  // Déclencheurs
  var delay = Math.max(0, parseInt(cfg.delay, 10) || 0);
  setTimeout(function () { open('delay'); }, delay * 1000);
  var scrollPct = parseInt(cfg.scroll, 10) || 0;
  if (scrollPct > 0) {
    var onScroll = function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      if (max > 0 && (h.scrollTop || window.pageYOffset) / max * 100 >= scrollPct) {
        window.removeEventListener('scroll', onScroll);
        open('scroll');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  if (cfg.exit && window.matchMedia('(pointer:fine)').matches) {
    document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0) open('exit'); });
  }

  // Fermeture
  root.querySelectorAll('[data-popup-close]').forEach(function (el) {
    el.addEventListener('click', function () { close(root.classList.contains('is-done') ? 'done' : 'dismiss'); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close('escape'); });

  // Inscription
  function showError(msg) { err.textContent = msg; err.hidden = false; input.classList.add('is-bad'); }
  input.addEventListener('input', function () { err.hidden = true; input.classList.remove('is-bad'); });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { showError('כתובת המייל לא נראית תקינה.'); input.focus(); return; }
    submit.classList.add('is-busy');
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source || 'Popup',
          profile: { data: { type: 'profile', attributes: { email: email, properties: { popup_source: cfg.source || 'Popup' } } } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.list } } }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo ' + r.status);
      done(email);
    }).catch(function () {
      submit.classList.remove('is-busy');
      showError('משהו השתבש. נסו שוב בעוד רגע.');
    });
  });

  function done(email) {
    lsSet(KEY_DONE, '1');
    root.classList.add('is-done');
    stepForm.hidden = true;
    stepDone.hidden = false;
    try { (window.klaviyo || []).push(['identify', { $email: email }]); } catch (e) {}
    // Pose le code sur la session Shopify : il sera pré-rempli à la caisse
    if (cfg.code) { try { fetch('/discount/' + encodeURIComponent(cfg.code), { credentials: 'same-origin' }).catch(function () {}); } catch (e) {} }
    track('popup_subscribed', { popup_source: cfg.source });
  }

  var copyBtn = root.querySelector('[data-popup-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var code = root.querySelector('[data-popup-code]').textContent.trim();
    var ok = function () { copyBtn.textContent = 'הועתק'; copyBtn.classList.add('is-ok'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok).catch(ok); else ok();
  });
})();
